/** Merge field patches. Keys set to `undefined` are removed so editor "Remove" actions stick. */
export function applyFieldUpdates<T extends object>(
  current: T | undefined,
  updates: Partial<T>
): T {
  const merged = { ...(current || {}), ...updates } as T;
  for (const key of Object.keys(updates)) {
    if ((updates as Record<string, unknown>)[key] === undefined) {
      delete (merged as Record<string, unknown>)[key];
    }
  }
  return merged;
}
